const basePath1 = '/assets/icons/logo/programs/';
const basePath2 = '/assets/icons/logo/socials/';
const basePath3 = '/assets/icons/logo/technologies/';
const basePath4 = '/assets/icons/logo/experiences/';
const basePath5 = '/assets/icons/interface/';
const basePath6 = '/assets/icons/logo/projects/';
const basePath7 = '/assets/pictures/projectphotos/';

const programs = {
    altium: basePath1 + 'altium.svg',
    autocad: basePath1 + 'autocad.svg',
    eplan: basePath1 + 'eplan.svg',
    matlab: basePath1 + 'matlab.svg',
    solidworks: basePath1 + 'solidworks.svg',
    stm32: basePath1 + 'stm32.png',
    tiaportal: basePath1 + 'tiaportal.png',
    vscode: basePath1 + 'vscode.png',
    c: basePath1 + 'c.svg',
    factoryio: basePath1 + 'factoryio.svg',
    figma: basePath1 + 'figma.svg',
    proteus: basePath1 + 'proteus.svg',
    davinci: basePath1 + 'davinci-resolve.svg',
    logic: basePath1 + 'logic-analyzer.svg',
    firebase: basePath1 + 'firebase.svg',
    arduino: basePath1 + 'arduino.svg',
}

const socials = {
    google: basePath2 + 'google.svg',
    github: basePath2 + 'github.svg',
    linkedin: basePath2 + 'linkedin.svg',
    instagram: basePath2 + 'instagram.svg',
}

const technologies = {
    css: basePath3 + 'css.svg',
    html: basePath3 + 'html.svg',
    js: basePath3 + 'js.svg',
    node: basePath3 + 'node.svg',
    react: basePath3 + 'react.svg',
    ts: basePath3 + 'ts.svg',
    chatgpt: basePath3 + 'chatgpt.svg',
    flutter: basePath3 + 'flutter.svg',
    mysql: basePath3 + 'mysql.svg',
    php: basePath3 + 'php.svg',
}

const experiences = {
    afl: basePath4 + 'afl.png',
    baun: basePath4 + 'baün.svg',
    coruh: basePath4 + 'coruh.svg',
    euas: basePath4 + 'euas.svg',
}

const interfaces = {
    user: basePath5 + 'user.svg',
}

const projects = {
    levitasyon: basePath6 + 'levitasyon.png',
    habiter: basePath6 + 'habiter.png',
    stm32: basePath6 + 'stm32p.png',
    microcontroller: basePath6 + 'microcontroller.png',
    dcmotor: basePath6 + 'dcmotor.png',
    robot: basePath6 + 'robot.jpg',
    plc1: basePath6 + 'plc1.png',
    plc2: basePath6 + 'plc2.png',
}


export const projectPhotos: Record<number, string[]> = {
    1: [
        basePath7 + "plcbit/plc1.png",
        basePath7 + "plcbit/plc2.png",
        basePath7 + "plcbit/plc3.png",
        basePath7 + "plcbit/plc4.png",
        basePath7 + "plcbit/plc5.png",
        basePath7 + "plcbit/plc6.png",
        basePath7 + "plcbit/plc7.png",
        basePath7 + "plcbit/plc8.png",
        basePath7 + "plcbit/plc9.png",
    ],
    2: [

    ],
    3: [
        basePath7 + "alanlar/alanlar1.png",
        basePath7 + "alanlar/alanlar2.png",
        basePath7 + "alanlar/alanlar3.png",
        basePath7 + "alanlar/alanlar4.png",
        basePath7 + "alanlar/alanlar5.png",
    ],
    4: [
        basePath7 + "pic/pic1.png",
        basePath7 + "pic/pic2.png",
        basePath7 + "pic/pic3.png",
        basePath7 + "pic/pic4.png",
        basePath7 + "pic/pic5.png",
    ],
    5: [
        basePath7 + "kontrol/kontrol1.png",
        basePath7 + "kontrol/kontrol2.png",
        basePath7 + "kontrol/kontrol3.png",
        basePath7 + "kontrol/kontrol4.png",
        basePath7 + "kontrol/kontrol5.png",
    ],
    6: [
        basePath7 + "habiter/habiter1.png",
        basePath7 + "habiter/habiter2.png",
        basePath7 + "habiter/habiter3.png",
        basePath7 + "habiter/habiter4.png",
        basePath7 + "habiter/habiter5.png",
        basePath7 + "habiter/habiter6.png",
        basePath7 + "habiter/habiter7.png",
        basePath7 + "habiter/habiter8.png",
    ],
    7: [
        basePath7 + "teksis/teksis1.png",
        basePath7 + "teksis/teksis2.png",
        basePath7 + "teksis/teksis3.png",
        basePath7 + "teksis/teksis4.png",
        basePath7 + "teksis/teksis5.png",
        basePath7 + "teksis/teksis6.png",
        basePath7 + "teksis/teksis7.png",
    ],
    8: [],
};

export const myIcons = {
    programs,
    socials,
    technologies,
    experiences,
    interfaces,
    projects,
    projectPhotos,
};